import { render, staticRenderFns } from "./ReferralCompleteOverlay.vue?vue&type=template&id=373f6978"
import script from "./ReferralCompleteOverlay.vue?vue&type=script&lang=js"
export * from "./ReferralCompleteOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports